import { Component } from '@angular/core';
import { ResourceListComponent } from '../../shared/resource-list/resource-list.component';

@Component({
  selector: 'app-files',
  standalone: true,
  imports: [ResourceListComponent],
  template: `<app-resource-list title="Files" apiPath="v1/files" />`
})
export class FilesComponent {}
